var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popover-loading-indicator"},[_c('div',{staticClass:"icon icon-loading popover-loading-indicator__icon"})])
}]

export { render, staticRenderFns }